import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { MessagesService } from '@core/_services/messages.service';
import { ConfirmationService } from 'primeng/api';
import { dateFormat } from '@core/_utils/date.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';
import { findItem, get_bskLabel, truncString } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'page-lock-docs',
    templateUrl: './page-lock-docs.component.html',
    styleUrls: ['./page-lock-docs.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PageLockDocsComponent implements OnInit {
    public selectedDocs: any[];
    public lockDocs = [];
    public isDesktop: boolean = false;
    public error = false;
    public itemConfirm: ItemConfirmComponent;

    public listColumns = [];

    constructor(
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService,
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.selectedDocs = new Array();
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('&doc_name'), field: 'doc_name', type: 'String', sort: 'doc_name' },
            { header: this.translate.instant('&doc_checkoutdate'), field: 'doc_checkoutdate', type: 'DateTime', sort: 'doc_checkoutdate' },
            { header: this.translate.instant('&doc_checkoutuser'), field: 'doc_checkoutuser', type: 'String', sort: 'doc_checkoutuser' },
            { header: this.translate.instant('&doc_checkoutreason'), field: 'doc_checkoutreason', type: 'String', sort: 'doc_checkoutreason' },
            { header: this.translate.instant('&doc_docid'), field: 'doc_docid', type: 'String' },
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getlockdocs',''));
            this.lockDocs = wRes.data.LockDocs.map((item) => {
                item.doc_checkoutdate = item.doc_checkoutdate + '|' + dateFormat(item.doc_checkoutdate, 'dd/MM/yyyy HH:mm:ss');
                item.doc_name = item.doc_name + item.doc_ext;
                if (item.bskList.length !== 0) {
                    item.bskList.map((elem) => {
                        elem.bsk_docdate = elem.bsk_docdate + '|' + dateFormat(elem.bsk_docdate, 'dd/MM/yyyy HH:mm:ss');
                        elem.bsk_label = this.getBasketLabel(elem.basketType, elem.basket, elem.bsk_name);
                    })
                }
                return item;
            });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private getBasketLabel(aBasketType, aType, aName) {
        let wBasket = [];
        let wBasketElem: any;
        let wLabel = aName;
        if (localStorage.getItem(aBasketType) !== 'undefined') {
            wBasket = JSON.parse(localStorage.getItem(aBasketType));
        };
        if (wBasket) {
            wBasketElem = wBasket[aType].filter((item) => {
                return (item.Information.Name === aName);
            });
            if (wBasketElem[0]) {
                wLabel = get_bskLabel(wBasketElem[0], aName);
            }
        }
        return wLabel;
    }

    public unLockDocs() {
        if (this.selectedDocs.length === 0) {
            this._messageService.addWarnNoStick(this.translate.instant('NoDoc_Sel'));
            return;
        }
        this.itemConfirm.confirmAction(
            'alert',
            this.translate.instant('UnLock_Docs'),
            () => {
                this.unLock();
            }
        );
    }

    public async unLock() {
        let wRes: any;
        let wList = '';
        this.selectedDocs.forEach((item) => {
            wList = wList + item.doc_docid + ',';
        });
        wList = truncString(wList, 1);
        const wParams = { Docid: wList };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('unlockdocuments', wParams));
            this.lockDocs = this.lockDocs.filter(item => {
                return (findItem(this.selectedDocs,item.doc_docid, 'doc_docid') === -1); 
            })
            this.selectedDocs = [];
            this._messageService.addSuccess(this.translate.instant('Work_OK'));            
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Unlock_KO'));            
        }
    }

    public clickcolck(event) {
        event.stopPropagation();
    }

}
